// const baseUrl="http://127.0.0.1:8000/api";
const baseUrl="https://asmweddingcards.com/backend/public/api";


export default baseUrl;